import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useHistory} from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import {faArrowLeft} from '@fortawesome/pro-regular-svg-icons'

import baseStyles from '../../css/Base.module.css';

export default function SecondaryAppBar({title, children, backURL}) {
  const history = useHistory();

  return (
    <div className={baseStyles['f-g-1']}>
      <AppBar position="sticky" className="bg-dark-blue">
        <Toolbar variant="dense">
          {backURL && (
            <IconButton
              edge="start"
              className="m-r-15"
              color="inherit"
              onClick={() => history.push(backURL)}
              size="large"
            >
              <FontAwesomeIcon icon={faArrowLeft} size="sm" />
            </IconButton>
          )}
          <Typography variant="h5" className={baseStyles['f-g-1']}>
            {title}
          </Typography>
          <div className="p-tb-5">{children}</div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
